import axios from 'axios';
import envService from "@/services/env.service";
import {logger} from "@/services/logger.service";


const BASE_URL = envService.getApiBaseUrl() + '/user';

const LOCAL_STORAGE_USER = "user";
const SESSION_STORAGE_VIEW_USER_EMAIL = "viewUserEmail";

export default {
    async initCsrfToken() {
        //Get CSRF Token
        axios.post(BASE_URL + '/csrf').finally(
            logger.debug("CSRF Token call done!")
        );
    },
    async updateUserInformation() {
        await this.removeLoggedInUser();
        let response = await axios.get(BASE_URL + '/info');
        await this.setLoggedInUser(response.data);
        this.initCsrfToken();
    },
    isLoggedIn() {
        return this.getLoggedInUser() !== undefined;
    },
    isAdmin() {
        return this.isLoggedIn() && (this.getLoggedInUser().admin === true);
    },
    clearUserData() {
        sessionStorage.clear();
        this.removeLoggedInUser();
    },
    async isLoggedInOnBackend() {
        if (!this.isLoggedIn()) {
            return false;
        }
        if (!envService.isDevMockEnv()) {
            // if not logged-in on backend this would result in 401 and then caught in axios default interceptor
            await this.updateUserInformation();
        }
        return true;
    },
    /** Get data of logged in user */
    getLoggedInUser() {
        let user = localStorage.getItem(LOCAL_STORAGE_USER);
        return user === undefined || user === null
            ? undefined
            : JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    },
    /** Login user (Set data of logged in user) */
    setLoggedInUser(user) {
        localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(user));
    },
    /** Logout user */
    removeLoggedInUser() {
        localStorage.removeItem(LOCAL_STORAGE_USER);
        this.removeViewUserEmail();
    },
    /** Get email of user to view (get selected email to show (if set) or real email of loggedin User) */
    getViewUserEmail() {
        let email = sessionStorage.getItem(SESSION_STORAGE_VIEW_USER_EMAIL);
        return email === undefined || email === null || email === ''
            ? this.getLoggedInUser().email
            : email;
    },
    /** Set email of user to view (only allowed in admin mode) */
    setViewUserEmail(email) {
        if (this.isAdmin()) {
            sessionStorage.setItem(SESSION_STORAGE_VIEW_USER_EMAIL, email);
        }
    },
    /** Remove email of user to view (admin mode) */
    removeViewUserEmail() {
        sessionStorage.removeItem(SESSION_STORAGE_VIEW_USER_EMAIL);
    },
    hasRight(role) {
        if (!this.isLoggedIn())
            return false
        let result = this.getLoggedInUser().roles.includes(role.toUpperCase())
        return result
    },
    hasRightSms() {
        return this.hasRight('ROLE_SMS') || this.isAdmin()
    },
    hasRightSendSms() {
        return this.hasRight('ROLE_SEND_SMS') || this.isAdmin()
    },
    hasRightReceiveSms() {
        return this.hasRight('ROLE_RECEIVE_SMS') || this.isAdmin()
    },
    hasRightCampaignManager() {
        return this.hasRight('ROLE_CAMPAIGN_MANAGER') || this.isAdmin()
    },
    hasRightAllowList() {
        return this.hasRightSms() || this.hasRightSendSms() || this.hasRightCampaignManager() || this.isAdmin()
    },
    hasRightBilling() {
        return this.hasRight('ROLE_BILLING') || this.isAdmin()
    },
};
